import styled, { css } from 'styled-components';
import { up } from 'styled-breakpoints';

import { TransientProps } from '@common/types';

type ContainerProps = Partial<
  TransientProps<{
    theaterMode: boolean;
  }>
>;

export const Container = styled.div<ContainerProps>`
  ${({ theme, $theaterMode }) => css`
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    max-height: calc(100vh - ${theme.layout.header} - 10rem);
    background: #000;
    border-radius: ${theme.radii.lg};
    overflow: hidden;
    box-shadow: ${theme.shadows.lg};
    transition: all 0.3s ease;

    ${up('lg')} {
      border-radius: ${theme.radii.lg};
    }

    ${$theaterMode &&
    css`
      width: 100%;
      height: 100%;
      max-height: none;
      border-radius: 0;
      aspect-ratio: auto;
      box-shadow: none;
    `}
  `}
`;

export const PlayerWrapper = styled.div`
  width: 100%;
  height: 100%;

  /* Override VideoPlayer container styles */
  > div {
    border-radius: 0;
    aspect-ratio: unset;
    height: 100%;
  }
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-color: #0f172a;
`;
